package com.matchpredictor.web

import kotlinx.browser.localStorage
import org.w3c.dom.HTMLInputElement

/**
 * Remember login without storing the password in app storage.
 * Username may be kept in localStorage; the password is left to the browser
 * password manager via autocomplete attributes on the form fields.
 */
object RememberedAuth {
    private const val REMEMBER_KEY = "fg_remember_login"
    private const val USERNAME_KEY = "fg_remembered_username"

    var rememberEnabled: Boolean
        get() = localStorage.getItem(REMEMBER_KEY) == "1"
        set(value) {
            if (value) localStorage.setItem(REMEMBER_KEY, "1")
            else {
                localStorage.removeItem(REMEMBER_KEY)
                localStorage.removeItem(USERNAME_KEY)
            }
        }

    var rememberedUsername: String?
        get() = localStorage.getItem(USERNAME_KEY)
        set(value) {
            if (value.isNullOrBlank()) localStorage.removeItem(USERNAME_KEY)
            else localStorage.setItem(USERNAME_KEY, value)
        }

    fun save(username: String, remember: Boolean) {
        rememberEnabled = remember
        if (!remember) return
        rememberedUsername = username
    }

    fun clear() {
        rememberEnabled = false
    }

    fun loadInto(usernameInput: HTMLInputElement) {
        if (!rememberEnabled) return
        rememberedUsername?.let { usernameInput.value = it }
    }
}

/** Default goose avatar / brand mark (registration achievement). */
const val DEFAULT_AVATAR_ICON = "registered"

private val rasterAchievementIcons = setOf(
    "registered",
    "first_prediction",
    "streak_3",
    "correct_10",
    "accuracy_70",
    "early_bird",
    "perfect_round",
    "goose_wife",
    "login_streak_3",
    "login_streak_7",
    "login_streak_30",
    "login_streak_365"
)

fun stickerImageUrl(icon: String): String {
    val name = icon.lowercase().substringBeforeLast('.')
    return "stickers/$name.png?v=20260809-pwa1e"
}

fun achievementImageUrl(icon: String): String {
    val name = icon.lowercase().substringBeforeLast('.')
    val ext = if (name in rasterAchievementIcons) "png" else "svg"
    return "achievements/$name.$ext"
}

fun formatUnlockDate(value: String?): String {
    if (value.isNullOrBlank()) return ""
    val date = value.substringBefore('T')
    val parts = date.split('-')
    return if (parts.size == 3) "${parts[2]}.${parts[1]}.${parts[0]}" else date
}
